var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96763 1.75C4.51647 1.75 1.71875 4.54772 1.71875 7.99888C1.71875 11.45 4.51647 14.2478 7.96763 14.2478C11.4188 14.2478 14.2165 11.45 14.2165 7.99888C14.2165 4.54772 11.4188 1.75 7.96763 1.75ZM7.21765 10.5C7.21765 10.0858 7.55344 9.75 7.96765 9.75H7.97223C8.38645 9.75 8.72223 10.0858 8.72223 10.5V10.5046C8.72223 10.9188 8.38645 11.2546 7.97223 11.2546H7.96765C7.55344 11.2546 7.21765 10.9188 7.21765 10.5046V10.5ZM8.71765 5.4502C8.71765 5.03598 8.38187 4.7002 7.96765 4.7002C7.55344 4.7002 7.21765 5.03598 7.21765 5.4502V8.2502C7.21765 8.66441 7.55344 9.0002 7.96765 9.0002C8.38187 9.0002 8.71765 8.66441 8.71765 8.2502V5.4502Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.ce3e506b772371b05969229407e61f04.svg";
export { ForwardRef as ReactComponent };